import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from 'Components/UI/BehavioralFormElement/Text/Input';
import { noop } from 'Helpers/PropTypes';
import { withHousehold } from 'Context/HouseholdContext';
import { ContextIndex } from './FieldList';
import { makeHideable } from '../Hideable';

import './index.css';
import withViewContext from './withViewContext';

class Text extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value, isReadonly },
      },
    } = props;

    this.state = {
      value,
      isReadonly: isReadonly === 'true',
      isDone: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => {
        this.setState({ value: res.attributes.value, isReadonly: res.attributes.isReadonly === 'true' }, () => {
          const {
            props: { name, onChange },
          } = this;
          onChange(name, res.attributes.value);
        });
      })
      .finally(() => this.setState({ isDone: true }));
  }

  onChange(value) {
    const { name, onChange } = this.props;
    this.setState({ value }, () => onChange(name, value));
  }

  onBlur() {
    const { householdId, uploadValue, answerKey } = this.props;
    const { value } = this.state;
    const index = this.context;
    uploadValue(householdId, answerKey, {
      attributes: {
        value,
        index,
      },
    });
  }

  render() {
    const { name, placeholder, readOnly } = this.props;
    const { value, isReadonly, isDone } = this.state;

    if (!isDone) {
      return null;
    }

    return (
      <div className="questionnaire-input">
        <Input
          value={value}
          label={placeholder}
          onBlur={e => this.onBlur(e)}
          onChange={(n, v) => {
            this.onChange(v);
          }}
          name={name}
          placeholder={placeholder}
          test={placeholder}
          readOnly={readOnly || isReadonly}
        />
      </div>
    );
  }
}

Text.propTypes = {
  name: PropTypes.string.isRequired,
  uploadValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  answerKey: PropTypes.string.isRequired,
  householdId: PropTypes.number.isRequired,
  apiResponse: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
};

Text.defaultProps = {
  onChange: noop,
  apiResponse: { attributes: {} },
  readOnly: false,
};

Text.contextType = ContextIndex;

const TextInput = withHousehold(withQuestionnaireFuncs(withViewContext(Text)));

export default makeHideable(TextInput);
